document.addEventListener('DOMContentLoaded', function () {
  const PUMP_LENGTHS = [9, 12];

  const PUMP_IMAGES = {
    '12': 'https://cdn.shopify.com/s/files/1/0528/1932/9203/files/12.jpg?v=1754277176',
    '9':  'https://cdn.shopify.com/s/files/1/0528/1932/9203/files/9.jpg?v=1754277176'
  };

  const penisLength = document.querySelector('#penis-length');

  const pumpImage  = document.querySelector('#pump-image');
  const penisImage = document.querySelector('.visual');

  const countLength = document.querySelector('.countLength');

  const unitPicker    = document.getElementById('unit-picker');
  const unitButtons   = unitPicker ? unitPicker.querySelectorAll('.seg-btn') : [];


  function pickRecommended(value, arr) {
    const min = value * 1.10;
    const max = value * 1.15;

    const inRange = arr.filter(v => v >= min && v <= max).sort((a, b) => a - b);
    if (inRange.length) return inRange[0];

    const bigger = arr.find(v => v >= min);
    if (bigger !== undefined) return bigger;

    return arr[arr.length - 1];
  }

  function setPumpImage(len) {
    const key = `${len}`;
    const url = PUMP_IMAGES[key];
    if (!url) return;

    if (pumpImage.src.split('?')[0] === url.split('?')[0]) {
      pumpImage.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now();
    } else {
      pumpImage.src = url;
    }
  }

  function inchesToCm(val) {
    return (val * 2.54).toFixed(2);
  }

  function updateVisualPenis() {
    penisImage.style.height = `${penisLength.value * 30}px`;
  }

  function updateDisplayedNumbers() {
    const lengthVal = parseFloat(penisLength.value);

    // if (switcher.checked) {
    //   countLength.innerHTML = `${inchesToCm(lengthVal)} cm`;
    // } else {
    //   countLength.innerHTML = `${lengthVal} inch`;
    // }
  }

  function recommendAndRender() {
    const userLen = parseFloat(penisLength.value);

    const recLen = pickRecommended(userLen, PUMP_LENGTHS);

    setPumpImage(recLen);
  }

  function updateAll() {
    updateVisualPenis();
    updateDisplayedNumbers();
    recommendAndRender();
  }

  penisLength.addEventListener('input', updateAll);

  if(unitPicker){
    unitButtons.forEach(btn=>{
      btn.addEventListener('click', function(){
        unitButtons.forEach(b=>b.classList.remove('active'));
        this.classList.add('active');
  
        const unit = this.dataset.unit;
        window.isMetric = (unit === 'cm');

        penisLength.value = penisLength.min;

        const ITEM_H = 40;

        function resetWheelCol(ul) {
          if (!ul) return;

          const holder = ul.closest('.wheel-separate') || ul.parentElement;
          const centerOffset = holder ? holder.clientHeight / 2 - ITEM_H / 2 : 0;

          ul.style.transition = 'none';
          ul.style.transform  = `translateY(${centerOffset}px)`;

          Array.from(ul.children).forEach((li, i) => {
            li.classList.toggle('active', i === 0);
          });
        }

        resetWheelCol(window.__wheels?.length?.ulWhole);
        resetWheelCol(window.__wheels?.length?.ulDec);

        dispatchInput(penisLength);
        updateAll();

        redrawWheelLabels();
        redrawSizesForCurrentUnit();
      });
    });
  }


  updateAll();
});